import { __rest } from "tslib";
import React from 'react';
import SlotClone from './slot-clone';
import { isSlottable } from './utils';
const SLOT_NAME = 'vulcanui-slot';
const Slot = React.forwardRef((props, forwardedRef) => {
    const { children } = props, slotProps = __rest(props, ["children"]);
    const childrenArray = React.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child) => {
            if (child === slottable) {
                if (React.Children.count(newElement) > 1)
                    return React.Children.only(null);
                return React.isValidElement(newElement)
                    ? newElement.props.children
                    : null;
            }
            else {
                return child;
            }
        });
        return (React.createElement(SlotClone, Object.assign({}, slotProps, { ref: forwardedRef }), React.isValidElement(newElement)
            ? React.cloneElement(newElement, undefined, newChildren)
            : null));
    }
    return (React.createElement(SlotClone, Object.assign({}, slotProps, { ref: forwardedRef }), children));
});
Slot.displayName = 'Slot';
Slot.toString = () => `.${SLOT_NAME}`;
export default Slot;
//# sourceMappingURL=slot.js.map